import type { PracticeTestExam } from "@memorang/types";

// TODO: use metadata or subtype when available
export const isSectionalTest = (test: PracticeTestExam): boolean =>
	test.title.toLowerCase().includes("sectional");

export const filterSectionalTests = (
	practiceTests: PracticeTestExam[],
): PracticeTestExam[] => practiceTests.filter(isSectionalTest);

export const filterFullPracticeTests = (
	practiceTests: PracticeTestExam[],
): PracticeTestExam[] => practiceTests.filter((item) => !isSectionalTest(item));
